// extracted by mini-css-extract-plugin
export default {"topRow":"ConnectServicePage_topRow__Bx5nt","title":"ConnectServicePage_title__fJkuU","container":"ConnectServicePage_container__bY6l7"};